import React from "react"
import Modal from "react-bootstrap/lib/Modal"
import Button from "react-bootstrap/lib/Button"

import VenueCategoriesChooser from "../VenueCategoriesChooser"
import VenueFeaturesChooser from "../VenueFeaturesChooser"

import style from "./index.module.sass"

export default function VenuesFilterModal(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    show,
    onClose,
    categories,
    onCategorySelected,
    onAllCategoriesSelected,
    selectedFeatures,
    onFeatureSelected,
    resultsCount,
    onClearFilterClicked,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <Modal
      show={show}
      onHide={onClose}
      animation={true}
      className="modal modal--full-height modal--no-footer-margin"
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-center">
          {I18n.t("pages.locations.venues.filters")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={style.filterSection}>
          {I18n.t("pages.locations.venues.features.title")}
        </div>
        <VenueFeaturesChooser
          selectedFeatures={selectedFeatures}
          onFeatureSelected={onFeatureSelected}
        />

        <div className={style.filterSection} style={{ marginTop: 40 }}>
          {I18n.t("pages.locations.venues.cuisines.title")}
        </div>

        <VenueCategoriesChooser
          categories={categories}
          onSelect={onCategorySelected}
          onAllCategoriesSelected={onAllCategoriesSelected}
        />
      </Modal.Body>

      <Modal.Footer className={style.footer}>
        <div
          className={style.venuesFilterModal__removeFilters}
          onClick={onClearFilterClicked}
        >
          <i className="fal fa-close mr-2" />
          {I18n.t("pages.locations.venues.features.remove_filters")}
        </div>
        <Button
          className="btn btn-sm btn-default"
          block
          disabled={resultsCount === 0}
          bsSize="large"
          bsStyle="primary"
          onClick={onClose}
        >
          <strong>{resultsCount}</strong>{" "}
          {resultsCount > 1
            ? I18n.t("pages.locations.venues.plural")
            : I18n.t("pages.locations.venues.singular")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
